//Performs a smooth page scroll to an anchor on the same page.
//Gets overriden by barba if it's not on the same page...
//Generell musste ich barba beibringen korrekt mit anchor links umzugehen... Bei neueren Versionen funktioniert das out of the box
$('.anchor-link').click(function() {
    var offset = 0; // <-- change the value here
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top + offset
            }, 1000);
            return false;
        }
    }
});


//first .type--heading on page is thinner

var typeHeadings = document.querySelectorAll('.type--heading');

if (typeHeadings.length > 0) {
    typeHeadings[0].style.fontWeight = "200";
}

//jump to top button

// function topFunction() {
//   document.body.scrollTop = 0; // For Safari
//   document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
// }

function topFunction() {
  // For modern browsers
  if (window.scrollTo) {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  } 
  // For Safari
  else if (document.body.scrollTop) {
    document.body.scrollTop = 0;
  } 
  // For other browsers
  else {
    document.documentElement.scrollTop = 0;
  }
}